var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap28X28(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_14372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1818 10.0546L21.3818 13.7455C21.1272 14 20.7454 14 20.4909 13.7455L17.1818 9.54547C17.0545 9.4182 17.0545 9.29093 16.9272 9.16366C16.6727 8.65457 16.5454 8.0182 16.5454 7.38184C16.5454 4.96366 18.4545 3.05457 20.8727 3.05457C23.2909 3.05457 25.2 4.96366 25.2 7.38184C25.2 7.63638 25.2 7.89093 25.0727 8.14547",
    stroke: "#0B0204",
    strokeWidth: 0.954545,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 8.5273C21.6326 8.5273 22.1454 8.01446 22.1454 7.38184C22.1454 6.74923 21.6326 6.23639 20.9999 6.23639C20.3673 6.23639 19.8545 6.74923 19.8545 7.38184C19.8545 8.01446 20.3673 8.5273 20.9999 8.5273Z",
    stroke: "#0B0204",
    strokeWidth: 0.954545,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9997 16.1636V22.9091C20.9997 23.5454 20.4906 23.9273 19.9815 23.9273H4.07238C3.43602 23.9273 3.0542 23.4182 3.0542 22.9091V18.2C3.0542 17.8182 3.18147 17.4364 3.43602 17.1818L5.98147 14.6364",
    stroke: "#0B0204",
    strokeWidth: 0.954545,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0542 12.3455V7.25457C3.0542 6.61821 3.56329 6.23639 4.07238 6.23639H14.7633",
    stroke: "#0B0204",
    strokeWidth: 0.954545,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0542 24.0546V16.5455C10.0542 16.1637 10.436 15.7819 10.8178 15.7819H20.9997",
    stroke: "#0B0204",
    strokeWidth: 0.954545,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7271 6.10907V9.54543",
    stroke: "#0B0204",
    strokeWidth: 0.954545,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_14372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.1636,
    height: 22.0182,
    fill: "white",
    transform: "translate(2.54541 2.54547)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap28X28);
export default __webpack_public_path__ + "static/media/map-28x28.1775c2bc82990a5df40fa469f4b71a89.svg";
export { ForwardRef as ReactComponent };